import type { ActivityContext, ActivityHandle } from '../../core/activity';
import { runAlgebraActivity } from '../../shared/algebra-runner';
import type { AlgebraLevel } from '../../shared/algebra-runner';
import levelsData from './levels.json';

export function mountAlgebraPlus(ctx: ActivityContext): ActivityHandle {
  return runAlgebraActivity(ctx, {
    activityId: 'algebra_plus',
    title: 'Adição',
    operator: '+',
    compute: (a, b) => a + b,
    levels: levelsData.levels as AlgebraLevel[],
  });
}
